import utils from 'utils';
import { etcloudIvat } from '../../../config' 
class declarationGenerationCtrl {
  constructor(
    $scope,
    httpRequest,
    $state,
    $stateParams,
    sweetalert,
    logger,
    initSortService,
    $timeout,
    authService,
    $filter,
    Upload,
    $uibModal
  ) {
    $scope.importBtnCollapsed = false;
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    // 查询的参数
    $scope.queryParam = {
      pageSize: 10,
      pageNum: 1,
      param: {
        applyPeriod: utils.getLastMonthFirstLast().preMonth,
        taxNo: '',
        companyName: '',
        dataSources: '',
        departmentNo: '',
        regionName: '',
        province: '',
        cityName: '',
        declarationStatus: '',
        state: '1',
      },
    };
    // 重置
    $scope.reset = function () {
      $scope.belleRegionCityList = [];
      $scope.queryParam.param = {
        companyName: '',
        taxNo: '',
        companyName: '',
        dataSources: '',
        departmentNo: '',
        regionName: '',
        province: '',
        cityName: '',
        declarationStatus: '',
        state: '1',
        applyPeriod: utils.getLastMonthFirstLast().preMonth,
      };
      getUserInfo()
    //   queryInfo();
    };
    // 选中的信息
    $scope.selectedRows = [];
    //自动查询展示
    const queryInfo = function queryInfo() {
      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;
      httpRequest
        .post_postSbIncomeList(queryDataHandle($scope.queryParam))
        .then((res) => {
          $scope.listData = res.data.value.list;
          $scope.totalItems = res.data.value.total;
          $scope.queryParam.pageNum = res.data.value.pageNum;
          $scope.queryParam.pageSize = res.data.value.pageSize;
          $scope.selectedRows = [];
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
    };
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList
        return queryData
    }
    // 搜索
    $scope.searchList = function () {
      queryInfo();
    };
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo();
    };
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo();
    };
    // 字典
    const typecodeArrStr = [
      'zzs_data', // 数据来源
      'department_no',
      'status',
      'glsale_declaration', //申报状态
      'zzs_status',
    ];
    $scope.dictionary = {};
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      $scope.dictData = $.extend($scope.dictionary, res.data.value);
    });
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    $scope.$watch('queryParam.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.queryParam.param.regionName == '') {
        $scope.belleRegionCityList = [];
        return;
      }
      angular.forEach($scope.dictData.department_no, function (item, index) {
        if (item.enumName === $scope.queryParam.param.departmentNo) {
          $scope.departmentNo = item.enumCode;
        }
      });
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode;
        }
      });
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    });
    // 获取所有主管税局信息
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // queryInfo();
    $scope.queryInfo = queryInfo;
    $scope.tableDropdownConfig = [
      {
        label: '删除',
        handler(item) {
          const params = {
            ids: [item],
          };
          sweetalert.confirm('删除提醒', '确认删除此信息').then(() => {
            httpRequest
              .post_batchSalesDelete(JSON.stringify(params), false)
              .then((res) => {
                if (res.data.msgCode == 90016) {
                  logger.logError(res.data.message);
                  // deletionErrorModal(res.data.message)
                  return;
                }
                logger.logSuccess('删除成功！');
                $scope.queryInfo();
              });
          });
        },
        showWhile(item, hasPermit) {
          return hasPermit('single_deletion');
        },
      },
    ];
    // 申报表导入
    $scope.uploadFiles = function uploadFiles(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError(
          '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
        );
        return;
      }
      if (file) {
        file.upload = Upload.upload({
          url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importSales`,
          data: {
            importFile: file,
            code: 'SB_GENERA_IMPORT',
            applyPeriod: $scope.queryParam.param.applyPeriod,
          },
        });
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        });
        file.upload.then(
          (res) => {
            $timeout(() => {
              if (!res.data.success) {
                layer.close(importinglayer);
                return logger.logError(res.data.message || '上传失败');
              }
              if (res.data.value.sourceCount === 0) {
                layer.close(importinglayer);
                return logger.logTips('导入数据为空！', 'warn');
              }
              const { batchNo, sourceCount, errorCount } = res.data.value;
              // 结果弹框
              // if (res.data.value.errorCount > 0) {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: 1,
                  pageSize: 10,
                  param: res.data.value.batchNo,
                })
                .then((res1) => {
                  layer.close(importinglayer);
                  $scope.importResultModal({
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: res1.data.value,
                  });
                  $scope.queryInfo();
                });
            });
          },
          (response) => {}
        );
      }
    };
    // 导入结果弹窗
    $scope.importResultModal = function (modalData) {
      const modalInstance = $uibModal.open({
        templateUrl: 'importResult.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.modalData = items1;
            $scope.list = items1.data.list;
            console.log($scope.modalData);
            $scope.pageOptions = {
              // 分页器
              totalItems: $scope.modalData.data.total,
              currentPage: ++$scope.modalData.data.prePage,
              maxSize: $scope.modalData.data.pageSize,
            };
            // 关闭
            $scope.ok = () => {
              $uibModalInstance.close();
            };
            // 分页查询
            $scope.pageChanged = () => {
              queryList();
            };
            function queryList() {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: $scope.pageOptions.currentPage,
                  pageSize: $scope.pageOptions.maxSize,
                  param: $scope.modalData.batchNo,
                })
                .then((res) => {
                  $scope.list = res.data.value.list;
                  $scope.pageOptions = {
                    // 分页器
                    totalItems: res.data.value.total,
                    currentPage: ++res.data.value.prePage,
                    maxSize: res.data.value.pageSize,
                  };
                });
            }
            // 导出错误详情
            $scope.downBatchInfo = function () {
              window.open(
                `${host.etcloudIvatApp}dl/dlTaskService/downBatchInfoDetail?batchNo=${$scope.modalData.batchNo}&accessToken=${localStorage.id_token}`
              );
            };
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal-importexcel',
        windowClass: 'mod-modal mod-modal-lg',
        bindToController: true,
        resolve: {
          items1() {
            return modalData;
          },
        },
      });
      modalInstance.result.then(
        () => {},
        () => {}
      );
    };
    // 模板下载
    $scope.downloadExcel = function () {
      window.open(
        `${
          host.etcloudIvatApp
        }taxdeclaration/rpaGsConfig/exportRpaGsConfigTemple?code=SB_GENERA_NOTIMPORT&accessToken=${localStorage.getItem(
          'id_token'
        )}`
      );
    };
    // 批量删除
    $scope.batchDeletion = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作');
      }
      let params = {
        ids: $scope.selectedRows,
      };
      httpRequest
        .post_batchSalesDelete(JSON.stringify(params), false)
        .then((res) => {
          if (res.data.msgCode == 90016) {
            logger.logError(res.data.message);
            return;
          }
          logger.logSuccess(res.data.value);
          $scope.queryInfo();
        });
    };
    // 批量删除错误弹框
    const deletionErrorModal = function (modalData) {
      const modalInstance = $uibModal.open({
        templateUrl: 'deletionErrorModal.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.resultData = modalData;
            $scope.ok = () => {
              $uibModalInstance.close();
            };
            $scope.cancel = () => {
              $uibModalInstance.dismiss();
            };
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        bindToController: true,
        resolve: {
          items1() {},
        },
      });
      modalInstance.result.then();
    };
    // 查询字段设置
    $scope.customizedConfig = {
      version: 1.66,
      queryConfig: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '数据来源',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属区域',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局省（市）',
          selected: false,
          default: false,
        },
        {
          label: '申报状态',
          selected: false,
          default: false,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '跟进人',
          selected: true,
          default: true,
        },
      ],
      table: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '数据来源',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: true,
          default: true,
        },
        {
          label: '所属区域',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: true,
          default: true,
        },
        {
          label: '主管税局省（市）',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '按适用税率计税销售额',
          selected: true,
          default: true,
        },
        {
          label: '按简易办法计税销售额',
          selected: true,
          default: true,
        },
        {
          label: '销项税额',
          selected: true,
          default: true,
        },
        {
          label: '进项税额',
          selected: true,
          default: true,
        },
        {
          label: '进项税额转出',
          selected: true,
          default: true,
        },
        {
          label: '简易计税办法计算的应纳税额',
          selected: true,
          default: true,
        },
        {
          label: '应纳税额合计',
          selected: true,
          default: true,
        },
        {
          label: '城建-本期应补(退)税额',
          selected: true,
          default: true,
        },
        {
          label: '教育附加-本期应补(退)税额',
          selected: true,
          default: true,
        },
        {
          label: '地方教育附加-本期应补(退)税额',
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '银行结算及刷卡收入',
          selected: true,
          default: true,
        },
        {
          label: '现金收款收入',
          selected: true,
          default: true,
        },
        {
          label: '未收款收入',
          selected: true,
          default: true,
        },
        {
          label: '跟进人',
          selected: true,
          default: true,
        },
      ],
    };
    //导出
    $scope.exportExel = function exportExel() {
      let fileName =
        '申报表生成(一般)_' +
        $scope.queryParam.param.applyPeriod.replace('-', '');
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
        'id_token'
      )}`;
      utils.file_download(
        url,
        $scope.queryParam.param,
        'gl_querygen', //type
        'POST',
        'blob',
        fileName,
        false
      );
    };
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo();
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
declarationGenerationCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  '$stateParams',
  'sweetalert',
  'logger',
  'initSortService',
  '$timeout',
  'authService',
  '$filter',
  'Upload',
  '$uibModal',
];
export default declarationGenerationCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declarationGeneration/declarationGenerationCtrl.js